/**
 * Envío UI-3 · marcas (panel "Marca" de la Vista Edición).
 * Mismas marcas que usa LMX: el servidor llama a los mismos handlers del MCP.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const brandService = {
  async list() {
    const { data } = await axios.get(`${API}/brands`);
    return data.brands || [];
  },
  async get(ref) {
    const { data } = await axios.get(`${API}/brands/${encodeURIComponent(ref)}`);
    return data;
  },
  async create({ name, fields, logoAssetId }) {
    const { data } = await axios.post(`${API}/brands`, {
      name, fields: fields || {}, logo_asset_id: logoAssetId || null,
    });
    return data;
  },
  async update(ref, patch) {
    const { data } = await axios.patch(`${API}/brands/${encodeURIComponent(ref)}`, patch);
    return data;
  },
  async palette(assetId, colors = 6) {
    const { data } = await axios.post(`${API}/brands/palette`, { asset_id: assetId, colors });
    return data.palette || [];
  },
  async forProject(projectId) {
    const { data } = await axios.get(`${API}/projects/${projectId}/brand`);
    return data;
  },
  // Envío LMX-4c · historial y uso de imágenes.
  async undo(ref, versionId = null) {
    const { data } = await axios.post(`${API}/brands/${encodeURIComponent(ref)}/undo`,
      versionId ? { version_id: versionId } : {});
    return data;
  },
  async history(ref) {
    const { data } = await axios.get(`${API}/brands/${encodeURIComponent(ref)}/history`);
    return data.versions || [];
  },
  async assetUsage(assetId) {
    try {
      const { data } = await axios.get(`${API}/brands/asset-usage/${encodeURIComponent(assetId)}`);
      return data.used_by || [];
    } catch { return []; }   // sin marcas o sin red: no bloquea el borrado
  },
  // Envío PJ-2 · borrado definitivo (la Biblioteca confirma antes).
  async remove(ref) {
    const { data } = await axios.delete(`${API}/brands/${encodeURIComponent(ref)}`);
    return data;
  },
  async assign(projectId, brandRef) {
    const { data } = await axios.put(`${API}/projects/${projectId}/brand`, { brand: brandRef || null });
    return data;
  },
};

export default brandService;
